import { COUNTRY_CODES } from "@redotech/locale/countries";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";

export const DHLExpressCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  countryCode: input<string>({ validator: nonEmptyValidator }),
  password: input<string>(),
  siteId: input<string>(),
});

export type DHLExpressCarrierValue = InputSchema.Value<
  typeof DHLExpressCarrierInput
>;

export type DHLExpressCarrierForm = InputSchema.Input<
  typeof DHLExpressCarrierInput
>;

export const dhlExpressCarrierDefault = (): DHLExpressCarrierValue => ({
  accountNumber: "",
  countryCode: "",
  password: "",
  siteId: "",
});

export const CreateDHLExpressCarrierForm = memo(
  function CreateDHLExpressCarrierForm({
    carrierInput,
  }: {
    carrierInput: DHLExpressCarrierForm;
  }) {
    const countryCodeOptions: RedoListItem<string>[] = COUNTRY_CODES.map(
      (code) => ({ id: code, type: "text", text: code, value: code }),
    );
    return (
      <>
        <RedoTextInput
          label="Account number"
          placeholder=""
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoSingleSelectDropdownInput
          label="Account country code"
          options={countryCodeOptions}
          optionSelected={({ item }) => {
            carrierInput.inputs.countryCode.setValue(item.value);
          }}
          selectedItem={countryCodeOptions.find(
            (option) => option.value === carrierInput.inputs.countryCode.value,
          )}
        />
        <RedoTextInput
          label="Password (optional)"
          placeholder=""
          setValue={carrierInput.inputs.password.setValue}
          value={carrierInput.inputs.password.value}
        />
        <RedoTextInput
          label="Site ID (optional)"
          placeholder=""
          setValue={carrierInput.inputs.siteId.setValue}
          value={carrierInput.inputs.siteId.value}
        />
      </>
    );
  },
);
